import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import StoryblokVue from '@storyblok/vue'

// import stylesheets
import '../src/assets/scss/main.scss'

const app = createApp(App)
app.use(router)
app.use(StoryblokVue)
app.mount('#app')
